export default __webpack_public_path__ + "static/media/AMLScreenImg.0ab50f8d.jpg";